import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilitiesService } from "../../helpers/utilities.service";
import { CompanyService } from "../../services/company.service";
import { Company } from "../../models/company";

@Component({
    selector: 'app-lectures',
    templateUrl: './lectures.component.html',
    styleUrls: ['./lectures.component.scss'],
})
export class LecturesComponent implements OnInit {
    private URL: string = "";

    allCompanies: Partial<Company>[]; // Kopija od site kompanii
    firstHalfCompanies: Partial<Company>[]; // Kompanii koi ke se samo vo prvata polovina na nastanot
    secondHalfCompanies: Partial<Company>[]; // Kompanii koi ke se samo vo vtorata polovina na nastanot

    
    firstHalfOdd : Partial<Company>[];
    firstHalfEven: Partial<Company>[];
    
    secondHalfOdd: Partial<Company>[];
    secondHalfEven: Partial<Company>[];

    constructor(private companyService: CompanyService,
        public sanitizer: DomSanitizer, private utils: UtilitiesService) {
            this.URL = this.utils.getStaticImageApi();
            this.companyService.getPartialCompanies().then(
                res => {
                    this.allCompanies = res;
                    this.filterCompaniesByPriority();
                    this.sortFIrst();
                    this.sortSecond();
                }).catch(console.log);
    }

    //Se delat firmite na dve listi vo zavisnost od toa dali se vo prva ili vtora polovina na nastanot
    filterCompaniesByPriority() {
        let priorityThreshold = this.allCompanies.length / 2;
        this.firstHalfCompanies = this.allCompanies.filter(company => company.priority <= priorityThreshold);
        this.secondHalfCompanies = this.allCompanies.filter(company => company.priority > priorityThreshold);
    }

    sortFIrst() {
        this.firstHalfEven = this.firstHalfCompanies.filter(company => company.priority % 2 == 0);
        this.firstHalfOdd = this.firstHalfCompanies.filter(company => company.priority % 2 == 1);
    }

    sortSecond(){
     
        this.secondHalfEven = this.secondHalfCompanies.filter(company => company.priority % 2 == 1);
        this.secondHalfOdd = this.secondHalfCompanies.filter(company => company.priority % 2 == 0);   
    }

    ngOnInit(): void {
    }
}

//this isnt it chief